import { DashboardTicketDTO } from '../../domain/models/DashboardTicket'
import { EditNotificationAreaDTO } from '../../domain/models/NotificationArea'
import { ListFilterTicketParam } from '../../domain/models/Ticket'
import { CreateTicketEvaluationsDTO } from '../../domain/models/TicketEvaluations'
import { TicketRepository } from '../../domain/repositories/TicketRepository'
import { TicketDatasourceAdapter } from '../datasources/TicketDatasource'

export function ticketRepository(
  ticketDatasource: TicketDatasourceAdapter
): TicketRepository {
  return {
    async listTicket({
      date,
      month,
      year,
      areaId,
      subAreaId,
      responsible,
      page,
      status,
      size
    }: DashboardTicketDTO) {
      return await ticketDatasource.listTicket({
        date,
        month,
        year,
        areaId,
        subAreaId,
        responsible,
        page,
        status,
        size
      })
    },
    async createTicket(data) {
      return await ticketDatasource.createTicket(data)
    },
    async ticketDetail(ticketId) {
      return await ticketDatasource.ticketDetail(ticketId)
    },
    async createAssignResponsibility({ ticketId, personaId }) {
      return await ticketDatasource.createAssignResponsibility({
        ticketId,
        personaId
      })
    },
    async createAssignPriority({ priority, ticketId }) {
      return await ticketDatasource.createAssignPriority({ priority, ticketId })
    },
    async createTicketEvaluation({
      ticketId,
      data
    }: {
      ticketId: string
      data: CreateTicketEvaluationsDTO
    }) {
      return await ticketDatasource.createTicketEvaluation({ ticketId, data })
    },
    async createTicketStatus({ ticketId, status }) {
      return await ticketDatasource.createTicketStatus({ ticketId, status })
    },
    async createAssignAttachment({ ticketId, data }) {
      return await ticketDatasource.createAssignAttachment({ ticketId, data })
    },
    async listTicketForAssignAttachment({ ticketId, areaId }) {
      return await ticketDatasource.listTicketForAssignAttachment({
        ticketId,
        areaId
      })
    },
    async listTicketsPersona({ personaId, date }) {
      return await ticketDatasource.listTicketsPersona({ personaId, date })
    },
    async listTicketsPatient({ patientId, date }) {
      return await ticketDatasource.listTicketsPatient({ patientId, date })
    },
    async listTicketsArea({ areaId, data }) {
      return await ticketDatasource.listTicketsArea({ areaId, data })
    },

    async listCompletedTicketsByArea({ areaId, data }) {
      return await ticketDatasource.listCompletedTicketsByArea({
        areaId,
        data
      })
    },

    async listResponsibleTicketIndicators({ data }) {
      return await ticketDatasource.listResponsibleTicketIndicators({ data })
    },

    async listTicketIndicators({ data }) {
      return await ticketDatasource.listTicketIndicators({ data })
    },
    async listAreas() {
      return await ticketDatasource.listAreas()
    },
    async updateSubArea({ areaId, subAreaId, data }) {
      return await ticketDatasource.updateSubArea({ areaId, subAreaId, data })
    },
    async listAreaPriorities({ areaId }) {
      return await ticketDatasource.listAreaPriorities({ areaId })
    },
    async updateAreaPriority({ areaId, data }) {
      return await ticketDatasource.updateAreaPriority({ areaId, data })
    },
    async createArea({ data }) {
      return await ticketDatasource.createArea({ data })
    },
    async createSubArea({ areaId, data }) {
      return await ticketDatasource.createSubArea({ areaId, data })
    },
    async listAreaResponsible({ areaId, subareaId }) {
      return await ticketDatasource.listAreaResponsible({ areaId, subareaId })
    },
    async createAreaResponsible({ areaId, personaId }) {
      return await ticketDatasource.createAreaResponsible({ areaId, personaId })
    },
    async createAreaAttendant({ areaId, personaId }) {
      return await ticketDatasource.createAreaAttendant({ areaId, personaId })
    },
    async listOperationalAreas({ operationalId }) {
      return await ticketDatasource.listOperationalAreas({ operationalId })
    },
    async listAreaById({ areaId }) {
      return await ticketDatasource.listAreaById({ areaId })
    },
    async deleteAreaId({ areaId }) {
      return await ticketDatasource.deleteAreaId({ areaId })
    },
    async listTicketDate({ personaId }) {
      return await ticketDatasource.listTicketDate({ personaId })
    },
    async listPatientTicketDate({ patientId }) {
      return await ticketDatasource.listPatientTicketDate({ patientId })
    },
    async listPersonaTicketArea() {
      return await ticketDatasource.listPersonaTicketArea()
    },
    async listNotificationsAreas() {
      return await ticketDatasource.listNotificationsAreas()
    },
    async createNotificationAreaAssociation(data) {
      return await ticketDatasource.createNotificationAreaAssociation(data)
    },
    async deleteNotificationAreaAssociation(associationId: string) {
      return await ticketDatasource.deleteNotificationAreaAssociation(
        associationId
      )
    },
    async editNotificationAreaAssociation({
      associationId,
      data
    }: {
      associationId: string
      data: EditNotificationAreaDTO
    }) {
      return await ticketDatasource.editNotificationAreaAssociation({
        associationId: associationId,
        data: data
      })
    },
    async adminUpdateArea({ areaId, data }) {
      return await ticketDatasource.adminUpdateArea({ areaId, data })
    },
    async operationalUpdateArea({ areaId, data }) {
      return await ticketDatasource.operationalUpdateArea({ areaId, data })
    },
    async operationalList() {
      return await ticketDatasource.operationalList()
    },
    async listNameArea() {
      return await ticketDatasource.listNameArea()
    },
    async listFilterTicket({ data }: { data: ListFilterTicketParam }) {
      return await ticketDatasource.listFilterTicket({ data })
    },
    async listAllResponsibleTheArea() {
      return await ticketDatasource.listAllResponsibleTheArea()
    },
    async listIndicatorsMetricsTma({ areaId, data }) {
      return await ticketDatasource.listIndicatorsMetricsTma({ areaId, data })
    },
    async listIndicatorsMetricsTme({ areaId, data }) {
      return await ticketDatasource.listIndicatorsMetricsTme({ areaId, data })
    },
    async listAgentsAndResponsiblesByArea({ areaId }) {
      return await ticketDatasource.listAgentsAndResponsiblesByArea({ areaId })
    }
  }
}
